import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyLetterFormatData,
  provideLetterFormatData
} from '@/composables/format-edit/useLetterFormatData'
import type { LetterExampleSentenceItem } from '@/components/format-edit/letter/LetterExampleSentenceDialog.vue'
import LetterCompanyCard from '@/components/format-edit/letter/LetterCompanyCard.vue'
import LetterTextWithExamplesCard from '@/components/format-edit/letter/LetterTextWithExamplesCard.vue'
import LetterResumeListCard from '@/components/format-edit/letter/LetterResumeListCard.vue'
import LetterCreateDateCard from '@/components/format-edit/letter/LetterCreateDateCard.vue'
import LetterConfirmCard from '@/components/format-edit/letter/LetterConfirmCard.vue'
import CompletedOutputPanel from '@/components/format-edit/completed/CompletedOutputPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: { errorMessages?: Record<string, string> } | null
  currentCardId?: string
  exampleSentences?: {
    intro?: LetterExampleSentenceItem[]
    entry?: LetterExampleSentenceItem[]
  }
};



const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'letter',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyLetterFormatData
})
provideLetterFormatData(formatData)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

const getMode = computed(() => process.env.VUE_APP_MODE)

const introSentences = computed(() => props.exampleSentences?.intro || [])
const entrySentences = computed(() => props.exampleSentences?.entry || [])

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

return { __sfc: true,props, formLib, formatData, mailPdfEnabled, downloadPdfEnabled, isSendYagiEmailEnabled, previewErrors, getMode, introSentences, entrySentences, dataChanged, LetterCompanyCard, LetterTextWithExamplesCard, LetterResumeListCard, LetterCreateDateCard, LetterConfirmCard, CompletedOutputPanel }
}

})